// extracted by mini-css-extract-plugin
export default {"name":"TableProvider_name__8cZbG","provider-name":"TableProvider_provider-name__TXu6c"};